import type { ReactNode } from "react"
import { createContext, useContext } from "react"

import { ZapOrchestrator } from "@/domains/minimal-pools-zap/zap-orchestrator"
import { TokenRepository } from "@/domains/tokens"

interface LiquidityPageContextValue {
  zapOrchestrator: ZapOrchestrator
  tokenRepository: TokenRepository
}

const LiquidityPageContext = createContext<LiquidityPageContextValue | null>(null)

export const useLiquidityPageContext = (): LiquidityPageContextValue => {
  const context = useContext(LiquidityPageContext)
  if (!context) {
    throw new Error("useLiquidityPageContext must be used within a LiquidityPageProvider")
  }
  return context
}

interface LiquidityPageProviderProps {
  children: ReactNode
  zapOrchestrator: ZapOrchestrator
  tokenRepository: TokenRepository
}

export const LiquidityPageProvider = ({ children, zapOrchestrator, tokenRepository }: LiquidityPageProviderProps) => {
  return (
    <LiquidityPageContext.Provider value={{ zapOrchestrator, tokenRepository }}>
      {children}
    </LiquidityPageContext.Provider>
  )
}
